const outDoorsAmbienceData = {
  id: "outdoorAmbience",
  name: "Outdoor&Ambience",
  iconsInfo: {
    electricityConsumption: "24",
    wifi: "20",
    airQuality: "136",
    electricityCon: "",
  },
  aqiValue: {
    day: 210,
    weekly: 137,
    monthly: 92,
    yearly: 51,
  },
  analytics: {
    day: [
      {
        node: "2022-10-11T11:00:00",
        count: 99.0,
      },
      {
        node: "2022-10-11T12:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T13:00:00",
        count: 100.0,
      },
      {
        node: "2022-10-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T15:00:00",
        count: 98.0,
      },
      {
        node: "2022-10-11T16:00:00",
        count: 67.0,
      },
      {
        node: "2022-10-11T17:00:00",
        count: 98.0,
      },
      {
        node: "2022-10-11T18:00:00",
        count: 57.0,
      },
      {
        node: "2022-10-11T19:00:00",
        count: 96.0,
      },
      {
        node: "2022-10-11T21:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T22:00:00",
        count: 90.0,
      },
      {
        node: "2022-10-11T17:00:00",
        count: 98.0,
      },
      {
        node: "2022-10-11T11:00:00",
        count: 99.0,
      },
      {
        node: "2022-10-11T12:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T13:00:00",
        count: 100.0,
      },
      {
        node: "2022-10-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T15:00:00",
        count: 98.0,
      },
      {
        node: "2022-10-11T16:00:00",
        count: 67.0,
      },
      {
        node: "2022-10-11T17:00:00",
        count: 98.0,
      },
      {
        node: "2022-10-11T18:00:00",
        count: 57.0,
      },
      {
        node: "2022-10-11T19:00:00",
        count: 96.0,
      },
      {
        node: "2022-10-11T21:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T22:00:00",
        count: 90.0,
      },
      {
        node: "2022-10-11T17:00:00",
        count: 98.0,
      },
    ],
    weekly: [
      {
        node: "2022-04-11T11:00:00",
        count: 100.0,
      },
      {
        node: "2022-05-11T12:00:00",
        count: 30.0,
      },
      {
        node: "2022-06-11T13:00:00",
        count: 77.0,
      },
      {
        node: "2022-07-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2022-08-11T15:00:00",
        count: 37.0,
      },
      {
        node: "2022-09-11T16:00:00",
        count: 27.0,
      },
      {
        node: "2022-10-11T17:00:00",
        count: 67.0,
      },
    ],
    monthly: [
      {
        node: "2022-10-11T11:00:00",
        count: 77.0,
      },
      {
        node: "2022-11-11T12:00:00",
        count: 27.0,
      },
      {
        node: "2022-12-11T13:00:00",
        count: 57.0,
      },
      {
        node: "2023-01-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2023-02-11T15:00:00",
        count: 87.0,
      },
      {
        node: "2023-03-11T16:00:00",
        count: 17.0,
      },
      {
        node: "2023-04-11T17:00:00",
        count: 27.0,
      },
      {
        node: "2023-05-11T18:00:00",
        count: 97.0,
      },
      {
        node: "2023-06-11T19:00:00",
        count: 87.0,
      },
      {
        node: "2023-07-11T21:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T11:00:00",
        count: 77.0,
      },
      {
        node: "2022-11-11T12:00:00",
        count: 27.0,
      },
      {
        node: "2022-12-11T13:00:00",
        count: 57.0,
      },
      {
        node: "2023-01-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2023-02-11T15:00:00",
        count: 87.0,
      },
      {
        node: "2023-03-11T16:00:00",
        count: 17.0,
      },
      {
        node: "2023-04-11T17:00:00",
        count: 27.0,
      },
      {
        node: "2023-05-11T18:00:00",
        count: 97.0,
      },
      {
        node: "2023-06-11T19:00:00",
        count: 87.0,
      },
      {
        node: "2023-07-11T21:00:00",
        count: 47.0,
      },
      {
        node: "2022-10-11T11:00:00",
        count: 77.0,
      },
      {
        node: "2022-11-11T12:00:00",
        count: 27.0,
      },
      {
        node: "2022-12-11T13:00:00",
        count: 57.0,
      },
      {
        node: "2023-01-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2023-02-11T15:00:00",
        count: 87.0,
      },
      {
        node: "2023-03-11T16:00:00",
        count: 17.0,
      },
      {
        node: "2023-04-11T17:00:00",
        count: 27.0,
      },
      {
        node: "2023-05-11T18:00:00",
        count: 97.0,
      },
      {
        node: "2023-06-11T19:00:00",
        count: 87.0,
      },
      {
        node: "2023-07-11T21:00:00",
        count: 47.0,
      },
    ],
    yearly: [
      {
        node: "2022-05-11T11:00:00",
        count: 17.0,
      },
      {
        node: "2022-06-11T12:00:00",
        count: 47.0,
      },
      {
        node: "2022-07-11T13:00:00",
        count: 57.0,
      },
      {
        node: "2022-08-11T14:00:00",
        count: 47.0,
      },
      {
        node: "2022-09-11T15:00:00",
        count: 87.0,
      },
      {
        node: "2022-10-11T16:00:00",
        count: 67.0,
      },
      {
        node: "2022-11-11T17:00:00",
        count: 27.0,
      },
      {
        node: "2022-12-11T18:00:00",
        count: 57.0,
      },
      {
        node: "2023-01-11T19:00:00",
        count: 87.0,
      },
      {
        node: "2023-02-11T21:00:00",
        count: 47.0,
      },
      {
        node: "2023-03-11T22:00:00",
        count: 77.0,
      },
      {
        node: "2022-11-11T17:00:00",
        count: 27.0,
      },
    ],
  },
  notifications: {
    events: {
      totalCount: "02",
      list: [
        {
          category: "outdoorAmbience",
          id: "evt-01",
          title: "Moderate AQI",
          subTitle1: "AQI- 100",
          subTitle2: "Park chop hill Bus parking",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.75572739114349,
            lng: -73.84642543119146,
          },
        },
        {
          category: "outdoorAmbience",
          id: "evt-02",
          title: "Good Signal Strength",
          subTitle1: "Wifi#16",
          subTitle2: "Parking Lot-C",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.756212594470774,
            lng: -73.84937992578129,
          },
        },
      ],
    },
    incidents: {
      totalCount: "05",
      list: [
        {
          category: "outdoorAmbience",
          id: "ict-01",
          title: "Hazardous AQI",
          subTitle1: "AQI-200",
          subTitle2: "Park chop hill Bus parking",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.75756638098499,
            lng: -73.84735433852819,
          },
        },
        {
          category: "outdoorAmbience",
          id: "ict-02",
          title: "High Electricity Consumption",
          subTitle1: "LP#12",
          subTitle2: "Parking Lot A",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.75853003429391,
            lng: -73.84705709631649,
          },
        },
        {
          category: "outdoorAmbience",
          id: "ict-03",
          title: "Low Bandwidth",
          subTitle1: "Wifi#32",
          subTitle2: "Left Field",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.7571482748172,
            lng: -73.84681583272432,
          },
        },
        {
          category: "outdoorAmbience",
          id: "ict-04",
          title: "Weak Signal Strength",
          subTitle1: "Wifi#42",
          subTitle2: "Stengel",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.7571245686096,
            lng: -73.84702381453208,
          },
        },
        {
          category: "outdoorAmbience",
          id: "ict-05",
          title: "High Electricity Consumption",
          subTitle1: "Wifi#42",
          subTitle2: "Left Field",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.75617286869527,
            lng: -73.84575078627893,
          },
        },
      ],
    },
    operationalAlerts: {
      totalCount: "02",
      list: [
        {
          category: "outdoorAmbience",
          id: "opr-01",
          title: "Not Operational",
          subTitle1: "Wifi #14",
          subTitle2: "Parking Slot B",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.756903977127216,
            lng: -73.84797234538736,
          },
        },
        {
          category: "outdoorAmbience",
          id: "opr-02",
          title: "Not Operational",
          subTitle1: "LP#15",
          subTitle2: "Lobby",
          timeStamp: "12-15-2022 | 09:00 AM",
          airQuality: "",
          voc: "",
          co2: "",
          pm2: "",
          pm10: "",
          img: "",
          video: "",
          location: {
            lat: 40.756437581297455,
            lng: -73.8469988531938,
          },
        },
      ],
    },
  },
};
export default outDoorsAmbienceData;
